import { useLocation } from "react-router-dom";
import { SITE_ORIGIN } from "@/lib/seo";

interface PageSchemaProps {
  /** schema.org type: WebPage for guides/category pages, CollectionPage for hubs, PodcastSeries for the show. */
  type?: "WebPage" | "CollectionPage" | "PodcastSeries";
  /** Must match the visible H1. */
  name: string;
  /** Must match the visible intro / meta description. */
  description: string;
  /** Extra page-specific fields (e.g. author, webFeed). */
  extra?: Record<string, unknown>;
}

/**
 * Emits one page-level JSON-LD node whose URL is the self-canonical
 * (SITE_ORIGIN + current path). Never use for Product/Offer/Rating.
 */
export default function PageSchema({ type = "WebPage", name, description, extra }: PageSchemaProps) {
  const { pathname } = useLocation();
  const url = `${SITE_ORIGIN}${pathname === "/" ? "/" : pathname.replace(/\/$/, "")}`;
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": type,
    name,
    description,
    url,
    inLanguage: "en-US",
    ...(type === "PodcastSeries"
      ? {}
      : { isPartOf: { "@type": "WebSite", url: `${SITE_ORIGIN}/`, name: "Juan The Trailer Guy" } }),
    publisher: { "@id": `${SITE_ORIGIN}/#organization` },
    ...extra,
  };
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />;
}
